import { type FC, memo } from 'react';
import StandardJackpot from '../../StandardJackpot';
import type { StandardJackpotProps } from '../../../types/jackpot.types';

import styles from './InstantLink.module.css';

const InstantLinkJackpot: FC<StandardJackpotProps> = (props) => {
  const instantLinkIcons = {
    grand: '/group_instant/grand'
  };

  return (
    <StandardJackpot
      {...props}
      icons={instantLinkIcons}
      className={styles.instantLinkTheme}
    />
  );
};

export default memo(InstantLinkJackpot);
